import { Container } from "@/shared/components/layout/Container";
import { Badge } from "@/shared/components/ui/Badge";
import { Stagger, StaggerItem } from "@/shared/components/motion/Stagger";
import { MarketingCtas } from "../MarketingCtas";
import { HeroContactCards } from "./HeroContactCards";

/**
 * Homepage hero. design.md §5 sanctions this section to keep its own `<section>`
 * for the `min-h-screen` + asymmetric padding the `marketing` preset can't
 * express. Two large, blurred, semantic-tinted blobs add warm glass depth —
 * decorative only (`aria-hidden`, `pointer-events-none`). The content wrapper is
 * `relative` so it paints above the absolutely-positioned blobs by DOM order,
 * which avoids a numeric z-index (§9). Animates on mount since it's above the
 * fold, using the shared motion vocabulary.
 */
export function HeroSection() {
  return (
    <section className="relative flex min-h-screen items-center overflow-hidden px-6 pb-20 pt-40 md:px-12 lg:px-24">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-24 h-96 w-96 rounded-full bg-brand-muted/40 blur-3xl" />
        <div className="absolute -right-24 top-1/3 h-[28rem] w-[28rem] rounded-full bg-accent-muted/30 blur-3xl" />
      </div>

      <Container size="5xl" className="relative">
        <Stagger onMount className="flex flex-col items-center gap-8 text-center">
          <StaggerItem>
            <Badge>No spreadsheets required</Badge>
          </StaggerItem>
          <StaggerItem>
            <h1 className="type-display-hero max-w-4xl text-text">
              Your guest list, beautifully organized.
            </h1>
          </StaggerItem>
          <StaggerItem>
            <p className="type-body-lg max-w-2xl text-text-muted">
              Collect, organize, and prepare your contacts for any event — all in
              one place.
            </p>
          </StaggerItem>
          <StaggerItem>
            <MarketingCtas
              primaryLabel="Get Started Free"
              secondaryLabel="Explore"
              secondaryScrollTo="problem"
              fullWidthMobile
              className="justify-center"
            />
          </StaggerItem>
          <StaggerItem className="mt-8 w-full">
            <HeroContactCards />
          </StaggerItem>
        </Stagger>
      </Container>
    </section>
  );
}
